export default __webpack_public_path__ + "static/media/tag.d6f00e6a.svg";